import "./Location.scss";
import { motion } from "framer-motion";
import { MapComponent } from "../../../components";
import useExecuteContext from "../../../utils/hooks/executeContext";
import { useEffect, useState, useRef } from "react";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";

const Location = ({ data }) => {
  const { locationData, setCurrentLocation, currentLocation } =
    useExecuteContext();
  useEffect(() => {
    setCurrentLocation(locationData?.[0]);
  }, []);

  const containerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // Check scroll position to determine arrow visibility
  const checkScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  // Scroll container by a fixed amount
  const scrollBy = (pixels) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: pixels,
        behavior: "smooth",
      });
    }
  };

  // Check scroll position on mount and when data changes
  useEffect(() => {
    checkScroll();
    // Add resize observer to handle window resizing
    const resizeObserver = new ResizeObserver(checkScroll);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [locationData]);

  return (
    <section className="location_map_wrap p_t p_b">
      <div className="content_wrap">
        <div className="title_line">
          <h2 className="darkGold">
            {data?.location_title
              ?.split("")
              .map((char, k) => (
                <motion.span
                  initial={{ translateX: 24, opacity: 0 }}
                  whileInView={{ translateX: 0, opacity: 1 }}
                  transition={{
                    duration: 0.4,
                    ease: "easeInOut",
                    delay: 0.05 * k,
                  }}
                  key={k}
                >
                  {char}
                </motion.span>
              ))
              .concat("")}
          </h2>
          <p className="darkGold">{data?.location_description}</p>
        </div>
   
        <div className="list_wrap" ref={containerRef} onScroll={checkScroll}>
          {locationData
            ?.filter((ele) => ele?.lat && ele?.lng)
            ?.map((data, k) => {
              return (
                <button
                  type="button"
                  className={`square_btn ${
                    currentLocation?._id === data?._id ? "active" : ""
                  }`}
                  key={k}
                  onClick={() => setCurrentLocation(data)}
                >
                  {data?.location}
                </button>
              );
            })}
        </div>
        {(showLeftArrow || showRightArrow) && (
          <div className="scroll_controle">
            {showLeftArrow ? (
              <button
                className="scroll-arrow left-arrow"
                onClick={() => scrollBy(-100)}
              >
               <GoArrowLeft />
              </button>
            ) : <p></p>}
            {showRightArrow ? (
              <button
                className="scroll-arrow right-arrow"
                onClick={() => scrollBy(100)}
              >
              <GoArrowRight />
              </button> 
            ) : <p></p>}
          </div>
        )}
        <div className="map_wrap">
          {locationData?.length > 0 && (
            <MapComponent locationData={locationData} card={true} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Location;
